import { NGET, NPOST } from '@/utils/net-work'
const baseUri = '/api'

function getRegions(params: any) {
  return NPOST(baseUri + '/auth/region-info', params)
}

function uploadSubmit(params: any) {
  return NPOST(baseUri + '/courseware/upload', params)
}

function getCourseBooks(params: any) {
  return NPOST(baseUri + '/courseware/books	', params)
}

function getAliyunToken() {
  return NPOST(baseUri + '/courseware/courseware_token', {})
}

function getSchoolList(params) {
  return NPOST(baseUri + '/auth/get-school', params)
}

function getUploadConfig() {
  return NGET(baseUri + '/paper/upload_config', {})
}

function uploadSubmitPaper(params: any) {
  return NPOST(baseUri + '/paper/upload', params)
}

export { getRegions, uploadSubmit, getCourseBooks, getAliyunToken, getSchoolList, getUploadConfig, uploadSubmitPaper }
